import React from "react";
import Marquee from "react-fast-marquee";
import {
  Apple,
  Beaker,
  CupSoda,
  Droplets,
  FlaskConical,
  Pill,
  Sparkles,
} from "lucide-react";
import abt1 from "../assets/abt-doctors.jpg";
import abt2 from "../assets/abt-doctor-2.jpg";
import abt3 from "../assets/abt-doctor-3.jpg";
import vision from "../assets/chemical.jpg";
import nabl from "../assets/certifications/nabl.png";
import fdca from "../assets/certifications/fdca.png";
import glp from "../assets/certifications/glp.png";
import duns from "../assets/certifications/duns.png";
import iso17025 from "../assets/certifications/iso.png";
import iso9001 from "../assets/certifications/iso-2.png";
import Banner from "../common-layouts/Banner";
import locationInfrastructureData from "../assets/data/locationInfrastructureData";


const certifications = [
  { title: "NABL", image: nabl },
  { title: "Gujarat State FDCA", image: fdca },
  { title: "GLP", image: glp },
  { title: "D-U-N-S Registered", image: duns },
  { title: "ISO/IEC 17025:2017", image: iso17025 },
  { title: "ISO 9001:2015", image: iso9001 },
];

const impactStats = [
  {
    value: "500+",
    label: "Clients supported consistently since inception",
  },
  {
    value: "650,000+",
    label:
      "Pharmaceutical samples analyzed through expert systems and quality practices",
  },
  {
    value: "2,000+",
    label:
      "Specialized projects completed in AMV, CDP, PV, Method Development, and more",
  },
];

const industries = [
  { title: "Pharmaceutical", Icon: Pill },
  { title: "Nutraceutical", Icon: Sparkles },
  { title: "Food", Icon: Apple },
  { title: "Cosmetics", Icon: FlaskConical },
  { title: "Chemicals", Icon: Beaker },
  { title: "Water", Icon: Droplets },
  { title: "Beverages", Icon: CupSoda },
];

const specializedServices = [
  "General Pharmaceutical Testing (IP, BP, USP, EP)",
  "Nitrosamine, NDSRI, Peptide Analysis & Validation",
  "Analytical Method Development & Validation (AMV)",
  "Method verification & comparative dissolution studies (CDP)",
  "Stability studies, R&D/F&D support activities",
];

const reasonsToChoose = [
  "Advanced facilities",
  "Expert team",
  "Proven track record",
  "Global reach",
  "Commitment to quality & compliance",
];

function About() {
  return (
    <>
      <div id="__next">
        <Banner title="About Us" />
        <section className="about-area pt-130 pb-20">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-4 col-12">
                <div
                  className="tp-about-thumb mb-60  fadeInLeft"
                  data--delay=".3s"
                >
                  <div className="tp-ab-img d-flex">
                    <div className="tp-ab-main-img p-relative">
                      <img data-aos="fade-right" src={abt1} alt="about-thumb" />
                      <div
                        className="about__exprience tp-ab-counter"
                        data-aos="fade-up"
                      >
                        <h3 className="counter">
                          <div className="d-flex align-items-center justify-content-center">
                            <span>10</span>
                          </div>
                        </h3>
                        <i>
                          Years of <br />
                          Experience
                        </i>
                      </div>
                    </div>
                    <div className="tp-ab-shape d-none d-md-block d-lg-none d-xl-block">
                      <img
                        className="ab-shape-one"
                        src={abt2}
                        alt="about-shape"
                        data-aos="fade-left"
                      />
                      <img
                        className="ab-shape-two"
                        src={abt3}
                        alt="abt3 shape"
                        data-aos="fade-left"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-8 col-12">
                <div
                  className="about-content about-align mb-60"
                  data--delay=".3s"
                >
                  <div className="tp-section" data-aos="fade-left">
                    <h3 className="tp-section__title ab-title mb-25">
                      Excellent Analysis with Assured Analytical Support!
                    </h3>
                    <p className="mr-20 mb-40">
                      Wave Analytical Labs LLP is one of the leading analytical service providers for the pharmaceutical and chemical industries in Gujarat, India. Established in 2016, our state-of-the-art facility spans 15,000 sq. ft., equipped with advanced instruments for world-class analytical chemistry services.
                    </p>
                    <div className="about-impact-grid">
                      {impactStats.map((item) => (
                        <div className="about-impact-card" key={item.value}>
                          <strong>{item.value}</strong>
                          <span>{item.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="about-details-area pt-40 pb-40">
          <div className="container">
            <div className="tp-section text-center mb-45" data-aos="fade-up">
              <span className="tp-section__sub-title left-line right-line mb-20">
                Accreditations & Certifications
              </span>
              <h3 className="tp-section__title mb-20">
                We are accredited and certified by
              </h3>
            </div>
            <div className="about-certification-grid" data-aos="fade-up">
              {certifications.map((certificate) => (
                <div className="about-certification-card" key={certificate.title}>
                  <img src={certificate.image} alt={certificate.title} />
                  <p>{certificate.title}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="about-details-area grey-bg pt-70 pb-70">
          <div className="container">
            <div className="row g-4">
              <div className="col-lg-6">
                <div className="about-info-panel" data-aos="fade-right">
                  <span className="tp-section__sub-title left-line mb-20">
                    Why Choose Us
                  </span>
                  <ul className="about-check-list">
                    {reasonsToChoose.map((reason) => (
                      <li key={reason}>{reason}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-info-panel" data-aos="fade-left">
                  <span className="tp-section__sub-title left-line mb-20">
                    Specialized Services
                  </span>
                  <ul className="about-check-list">
                    {specializedServices.map((service) => (
                      <li key={service}>{service}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-12">
                <div className="about-industries-line" data-aos="fade-up">
                  <span className="tp-section__sub-title left-line mb-0">
                    Industries We Serve
                  </span>
                  <div className="about-industries-marquee">
                    <Marquee gradient={false} speed={35} pauseOnHover>
                      {industries.map((industry) => (
                        <span
                          className="about-industry-badge"
                          key={industry.title}
                        >
                          <span className="about-industry-icon">
                            <industry.Icon size={30} strokeWidth={2.1} />
                          </span>
                          {industry.title}
                        </span>
                      ))}
                    </Marquee>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="about-story-area pt-70 pb-50">
          <div className="container">
            <div className="row g-4 align-items-center">
              <div className="col-xl-4 col-lg-4 col-md-12">
                <div
                  className="about-story-content about-story-content--team"
                  data-aos="fade-right"
                  data--delay=".2s"
                >
                  <span className="tp-section__sub-title left-line mb-20">
                    Our Team
                  </span>
                  <p>
                    Wave Analytical Labs LLP is directed and operated by a
                    highly qualified team of professionals and academicians. We
                    are recognized for building strong client relationships and
                    providing unmatched technical support. Additionally, we
                    collaborate with educational and research institutes,
                    offering guidance and expertise to foster innovation.
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-12">
                <div
                  className="about-story-image"
                  data-aos="fade-up"
                  data--delay=".2s"
                >
                  <img src={vision} alt="vision" className="vision" />
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-12">
                <div
                  className="about-story-content about-story-content--vision"
                  data-aos="fade-left"
                  data--delay=".2s"
                >
                  <span className="tp-section__sub-title left-line mb-20">
                    Our Vision
                  </span>
                  <p>
                    To enrich the value of pharmaceutical, food, cosmetics, and
                    allied industries by being the most trusted organization for
                    Analytical Testing and Support Services, thereby
                    safeguarding public health.
                  </p>
                  <p>
                    At Wave Analytical Labs LLP, we adhere to global standards
                    and operate with a customer-centric attitude. We
                    continuously enhance our quality benchmarks, internal
                    processes, team management, and technical expertise to
                    deliver superior services to our clients.
                  </p>
                  <p>
                    Wave Analytical Labs LLP remains determined and focused on
                    providing accurate and precise results, ensuring the
                    well-being of society through scientific excellence and
                    integrity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="services-area pt-95 pb-90 grey-bg mt-60 fix">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 col-md-8 col-12">
                <div className="tp-section" data-aos="fade">
                  <span className="tp-section__sub-title left-line mb-20">
                    Location & Infrastructure
                  </span>
                  <h6 className="mb-50">
                    Our facility has been thoughtfully designed at a prime location in Ahmedabad, ensuring ease of access for both clients and employees. This strategic positioning reflects our commitment to convenience, professionalism, and excellence in service.
                  </h6>
                </div>
              </div>
            </div>
            <div className="row location-infrastructure-grid" data-aos="fade-up">
              {locationInfrastructureData.map((item) =>
                item.variant === "lab" ? (
                  <div
                    className="location-infrastructure-col col-md-6"
                    key={item.id}
                  >
                    <div className="counter__item blue-border mb-30 p-3">
                      <div className="counter__icon blue-hard mb-15 lab-card px-5 p-2 ">
                        <img src={item.icon} alt="" id="lab-icon" />
                      </div>
                      <div className="counter__content">
                        <p className="loc-title">{item.title}</p>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="location-infrastructure-col col-md-6"
                    key={item.id}
                  >
                    <div
                      className="counter__item blue-border mb-30  fadeInUp"
                      data--delay=".2s"
                    >
                      <div className="counter__icon blue-hard mb-15">
                        <img src={item.icon} id="icons" alt="" />
                      </div>
                      <div className="counter__content">
                        <p className="loc-title">{item.title}</p>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default About;
